{
  "en": {
    "draught": "Draught",
    "tide": "Tide",
    "sounding": "Soundings"
  },
  "fr": {
    "draught": "Tirant d'eau",
    "tide": "Marée",
    "sounding": "Sondes"
  }
}